module.exports = __webpack_public_path__ + "img/undraw_dog_walking.a8a9ca07.svg";